import { useEffect } from 'react';
import { IframeOpener } from '../../vanillaComponent/iframe-opener';
import { IframeInjector } from '../../vanillaComponent/xrm-lead-gen';

function LeadGenWidget() {
  useEffect(() => {
    try {
      const openIframeContainer = document.getElementById('open-iframe');
      const openIframeEmbedContainer = document.getElementById('open-iframe-embed');

      if (openIframeContainer && !openIframeContainer.querySelector('[id^="open-iframe-button"]')) {
        const widgetData = {
          token: 'OGtJeDhFMnIyMjlOWndnNzRxRzFoczhi',
          type: 'button',
          version: '1.0',
          module: 'lead-gen',
        };

        new IframeOpener(widgetData).render(openIframeContainer);
      }

      if (openIframeEmbedContainer && !openIframeEmbedContainer.querySelector('[id^="lead-gen-in-injector"]')) {
        const widgetData = {
          token: 'OGtJeDhFMnIyMjlOWndnNzRxRzFoczhi',
          type: 'embed',
          version: '1.0',
          module: 'lead-gen',
        };

        new IframeInjector(widgetData).render(openIframeEmbedContainer);
      }
    } catch (error) {
      console.error('Error initializing LeadGenWidget:', error);
    }

    // If you need to clean up or perform actions when the component is unmounted,
    // you can return a cleanup function from the useEffect.
    return () => {
      // Cleanup logic (if needed)
    };
  }, []); // Empty dependency array means this effect runs only once

  return (
    <>
      <div id='open-iframe'></div>
      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {/* <div id='open-iframe'></div> */}
      </div>
      <div id='open-iframe-embed'></div>
    </>
  );
}

export default LeadGenWidget;
